import { apiFetch } from "./apiClient";

export interface AuthResponse {
  token: string;
  expiresAt: string;
}

export const loginRequest = async (
  email: string,
  password: string
): Promise<AuthResponse> => {
  const response = await apiFetch("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
  return response.json();
};

/** Maps to the backend's UserDto as returned by GET /auth/me. */
export interface CurrentUserDto {
  userId: number;
  accountId: number;
  branchId: number | null;
  userName: string;
  email: string | null;
  mobileNo: string | null;
  roleId: number;
  roleName: string | null;
  roleCode: string | null;
  isActive: boolean;
  createdOn: string;
  modifiedOn: string | null;
}

/** The logged-in user's own profile, read server-side from their token's
 * `sub` claim — the reliable source for `accountId` (the JWT itself never
 * carries an accountId claim, see jwtIdentity.ts). */
export const getCurrentUser = async (): Promise<CurrentUserDto> => {
  const response = await apiFetch("/auth/me");
  return response.json();
};
